import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { registerSW } from "@/lib/pwa";
import App from "@/App";

registerSW();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
